/**
 * Báo giá nhanh từ web PCCC (DEC-521, anh Tiến 26/10/2026): khách gửi thông tin + file bản vẽ / danh mục vật tư,
 * yêu cầu vào ERP cho NV kinh doanh nhận và lập báo giá. Dùng chung cho API (kiểm tra) và web ERP (hiển thị).
 */
export const WEB_QUOTE_PREFIX = 'WQ';
export const WEB_QUOTE_MAX_FILES = 5;
export const WEB_QUOTE_MAX_FILE_BYTES = 15 * 1024 * 1024;
export const WEB_QUOTE_MAX_TOTAL_BYTES = 25 * 1024 * 1024;
export const WEB_QUOTE_MAX_ITEMS = 60;

/** Đuôi file khách được gửi → loại MIME lưu kèm (không tin MIME trình duyệt gửi) */
export const WEB_QUOTE_FILE_TYPES: Record<string, string> = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  dwg: 'image/vnd.dwg',
  dxf: 'image/vnd.dxf',
};
export const WEB_QUOTE_EXTENSIONS = Object.keys(WEB_QUOTE_FILE_TYPES);

export function webQuoteFileType(name: string): string | null {
  const ext = name.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1];
  return ext ? (WEB_QUOTE_FILE_TYPES[ext] ?? null) : null;
}

export const WEB_QUOTE_STATUSES = ['new', 'assigned', 'quoted', 'closed'] as const;
export type WebQuoteStatus = (typeof WEB_QUOTE_STATUSES)[number];
export const WEB_QUOTE_STATUS_LABELS: Record<WebQuoteStatus, string> = {
  new: 'Chờ nhận',
  assigned: 'Đã nhận',
  quoted: 'Đã báo giá',
  closed: 'Đã đóng',
};
